import {Navigate, Outlet} from "react-router";
import {CompanyAuthProvider, useCompanyAuth} from "../contexts/CompanyAuthContext";
import {PATHS} from "./paths";
import {RouteLoader} from "./RouteLoader";

/**
 * Гарды кабинета компаний.
 *
 * До этого маршруты /company/* не были закрыты ничем: /company/dashboard
 * открывался без сессии вообще. ProtectedRoute здесь не подходит — он
 * проверяет пользовательскую сессию, а у компании она своя.
 */

/**
 * Одна сессия на весь кабинет.
 *
 * Провайдер стоит НАД гардами, а не внутри каждого. Когда он был внутри, вход и
 * закрытая часть держали по своему экземпляру: после логина React размонтировал
 * провайдер гостевой ветки и монтировал новый — тот начинал с loading=true,
 * выбрасывал только что полученную из login() компанию и заново спрашивал
 * /api/company/me. Между формой входа и кабинетом успевал мигнуть
 * полноэкранный RouteLoader. Теперь состояние переживает переход: после входа
 * кабинет открывается сразу.
 */
export function CompanyAuthLayout() {
    return (
        <CompanyAuthProvider>
            <Outlet/>
        </CompanyAuthProvider>
    );
}

/** Закрытая часть кабинета: дашборд и формы мест. */
export function CompanyProtectedRoute() {
    const {isAuthenticated, loading} = useCompanyAuth();

    if (loading) return <RouteLoader/>;
    if (!isAuthenticated) return <Navigate to={PATHS.company.login} replace/>;

    return <Outlet/>;
}

/** Вход и регистрация: только для тех, кто ещё не в кабинете. */
export function CompanyGuestRoute() {
    const {isAuthenticated, loading} = useCompanyAuth();

    if (loading) return <RouteLoader/>;
    // С живой сессией форма входа/регистрации бессмысленна — сразу в кабинет.
    if (isAuthenticated) return <Navigate to={PATHS.company.dashboard} replace/>;

    return <Outlet/>;
}
